import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const ROWS = [{
  without: 'Every class starts from zero',
  with: 'Every lesson already organized'
}, {
  without: 'Students quietly disappear',
  with: 'Students stay longer'
}, {
  without: 'You answer messages all day',
  with: 'Ready-to-send templates'
}, {
  without: 'Weekend spent planning',
  with: 'Plug-and-play class plans'
}, {
  without: 'Income depends on memory',
  with: 'Professional systems'
}, {
  without: 'Everything lives in your head',
  with: 'Everything documented'
}];
export function ComparisonTable() {
  return <section className="px-5 py-8" data-id="element-37" data-mp="38dt4rtjzv2ai">
      <div className="mx-auto max-w-xl" data-id="element-38" data-mp="3dcvywiyfro3p">
        <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-39" data-mp="3dbuo8flc13mi">
          Without the Kit vs. With
          <span className="block text-[var(--pb-lime)]" data-id="element-40" data-mp="1x18oc67ohb3j">
            Pickleball Coach 360
          </span>
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-41" data-mp="2dx5pnuldwd4d">
          {/* Without */}
          <div className="rounded-2xl border border-red-300/35 bg-[#251827]/95 p-3 shadow-lg shadow-black/20" data-id="element-42" data-mp="29vttf6808tn7">
            <p className="mb-3 text-center text-xs font-800 uppercase tracking-wide text-red-200" data-id="element-43" data-mp="2nvbog3bw9350">
              Without
            </p>
            <ul className="space-y-2" data-id="element-44" data-mp="2ivqobpkzmoqp">
              {ROWS.map(r => <li key={r.without} className="flex items-start gap-1.5" data-id="element-45" data-mp="2wvrr5aktc68t">
                  <XIcon size={14} className="mt-0.5 shrink-0 text-red-400" data-id="element-46" data-mp="2suo70bvqfo1s" />
                  <span className="text-[12px] leading-snug text-white/70" data-id="element-47" data-mp="2sslm269fsl3x">
                    {r.without}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="rounded-2xl border border-[var(--pb-lime)]/45 bg-[#16263b]/95 p-3 shadow-lg shadow-black/20" data-id="element-48" data-mp="3gka9p9bbclej">
            <p className="mb-3 text-center text-xs font-800 uppercase tracking-wide text-[var(--pb-lime)]" data-id="element-49" data-mp="3blywqppq1us3">
              With Pickleball Coach 360
            </p>
            <ul className="space-y-2" data-id="element-50" data-mp="3imj9xlhgq7le">
              {ROWS.map(r => <li key={r.with} className="flex items-start gap-1.5" data-id="element-51" data-mp="3nnqhbjfp14rj">
                  <CheckIcon size={14} className="mt-0.5 shrink-0 text-[var(--pb-lime)]" data-id="element-52" data-mp="3sliil428a38e" />
                  <span className="text-[12px] font-500 leading-snug text-white" data-id="element-53" data-mp="19p9pdb0bm78">
                    {r.with}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}